/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { ListOfferingsApiV1MasterDataOfferingsGetParams } from '../models/listOfferingsApiV1MasterDataOfferingsGetParams';

import type { Offering } from '../models/offering';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * List the tenant's offerings (the polymorphic catalog supertype).
 * @summary List Offerings
 */
export const listOfferingsApiV1MasterDataOfferingsGet = (
  params?: ListOfferingsApiV1MasterDataOfferingsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<Offering[]>({
    url: `/api/v1/master-data/offerings`,
    method: 'GET',
    params,
    signal
  });
};

export const getListOfferingsApiV1MasterDataOfferingsGetQueryKey = (
  params?: ListOfferingsApiV1MasterDataOfferingsGetParams
) => {
  return [
    `/api/v1/master-data/offerings`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListOfferingsApiV1MasterDataOfferingsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>,
  TError = HTTPValidationError
>(
  params?: ListOfferingsApiV1MasterDataOfferingsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOfferingsApiV1MasterDataOfferingsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>
  > = ({ signal }) => listOfferingsApiV1MasterDataOfferingsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListOfferingsApiV1MasterDataOfferingsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>
>;
export type ListOfferingsApiV1MasterDataOfferingsGetQueryError =
  HTTPValidationError;

export function useListOfferingsApiV1MasterDataOfferingsGet<
  TData = Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListOfferingsApiV1MasterDataOfferingsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>,
          TError,
          Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListOfferingsApiV1MasterDataOfferingsGet<
  TData = Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>,
  TError = HTTPValidationError
>(
  params?: ListOfferingsApiV1MasterDataOfferingsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>,
          TError,
          Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListOfferingsApiV1MasterDataOfferingsGet<
  TData = Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>,
  TError = HTTPValidationError
>(
  params?: ListOfferingsApiV1MasterDataOfferingsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Offerings
 */

export function useListOfferingsApiV1MasterDataOfferingsGet<
  TData = Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>,
  TError = HTTPValidationError
>(
  params?: ListOfferingsApiV1MasterDataOfferingsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOfferingsApiV1MasterDataOfferingsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListOfferingsApiV1MasterDataOfferingsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single offering by id.
 * @summary Get Offering
 */
export const getOfferingApiV1MasterDataOfferingsOfferingIdGet = (
  offeringId: string,
  signal?: AbortSignal
) => {
  return customInstance<Offering>({
    url: `/api/v1/master-data/offerings/${offeringId}`,
    method: 'GET',
    signal
  });
};

export const getGetOfferingApiV1MasterDataOfferingsOfferingIdGetQueryKey = (
  offeringId?: string
) => {
  return [`/api/v1/master-data/offerings/${offeringId}`] as const;
};

export const getGetOfferingApiV1MasterDataOfferingsOfferingIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
  >,
  TError = HTTPValidationError
>(
  offeringId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetOfferingApiV1MasterDataOfferingsOfferingIdGetQueryKey(offeringId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>>
  > = ({ signal }) =>
    getOfferingApiV1MasterDataOfferingsOfferingIdGet(offeringId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!offeringId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOfferingApiV1MasterDataOfferingsOfferingIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>>
  >;
export type GetOfferingApiV1MasterDataOfferingsOfferingIdGetQueryError =
  HTTPValidationError;

export function useGetOfferingApiV1MasterDataOfferingsOfferingIdGet<
  TData = Awaited<
    ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
  >,
  TError = HTTPValidationError
>(
  offeringId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOfferingApiV1MasterDataOfferingsOfferingIdGet<
  TData = Awaited<
    ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
  >,
  TError = HTTPValidationError
>(
  offeringId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOfferingApiV1MasterDataOfferingsOfferingIdGet<
  TData = Awaited<
    ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
  >,
  TError = HTTPValidationError
>(
  offeringId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Offering
 */

export function useGetOfferingApiV1MasterDataOfferingsOfferingIdGet<
  TData = Awaited<
    ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
  >,
  TError = HTTPValidationError
>(
  offeringId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getOfferingApiV1MasterDataOfferingsOfferingIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetOfferingApiV1MasterDataOfferingsOfferingIdGetQueryOptions(
      offeringId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
